var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._b({attrs:{"multiple":_vm.multiple}},'select',_vm.page.validation('bu_level'),false),[_vm._t("default"),_vm._l((_vm.options),function(v,k){return _c('option',{key:k,domProps:{"value":_vm.object?v[_vm.object[0]]:k}},[_vm._v(_vm._s(_vm.optValue(v)))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }